module.exports = __webpack_public_path__ + "assets/img/appointment-head-back2.0d801d60.png";